<app-select-filter #selectFilter
                   (_onSingleSelectionChange)="selectionChanged($event)"
                   [elements]="elements"
                   [filterElementProcessor]="filter"
                   [noEntriesFoundLabel]="noValueLabel"
                   [parentFormControlName]="parentFormControlName"
                   [newItemModalOptions]="formattedNewItemModalOptions"
                   [parentFormGroup]="parentFormGroup">
    <ng-template let-element='element' template-content>
        {{element.label}} <span style="font-size: 0.7em;">({{element.category?.label}})</span>
    </ng-template>
</app-select-filter>

